import React from 'react'
import { useLocation } from 'react-router-dom'

import ContentView from './ContentView'

const ContentViewContainer = (): JSX.Element => {
  const location = useLocation()

  // Determine content type from URL pathname
  const contentType = location.pathname.includes('/discover/catalog')
    ? 'catalog'
    : 'playlist'

  return <ContentView location={location} contentType={contentType} />
}

export default ContentViewContainer
